/**
 * MarketingGrowthContainer — Multi-tab Growth dashboard
 * Always renders GrowthDashboardContent with all tabs (CEO, Vendas, Canais, etc.)
 * Meta Ads tab uses GrowthCommandCenter for executive decision-making
 */
import React from "react";
import GrowthDashboardContent from "@/components/dashboard/GrowthDashboardContent";

export default function MarketingGrowthContainer({ authAxios, showHeader = false, showPeriodSelector = true }) {
  return (
    <GrowthDashboardContent authAxios={authAxios} showHeader={showHeader} showPeriodSelector={showPeriodSelector} />
  );
}
